module.exports = __webpack_public_path__ + "media/src/assets/images/avatar-48b3a5962aca862976af1792c1e78fb2.png";